export default __webpack_public_path__ + "static/cover-650ea0d21f00ced9077e5192edb3c301.jpg";